import { ISampleCount } from "pages/imageCreator/components/ExtraAction";
import { CREDITS_PER_IMAGE } from "utils/creditUtils";

export const sampleOptions: ISampleCount[] = [
  {
    label: `1 Sample (uses ${CREDITS_PER_IMAGE} credits)`,
    value: 1,
  },
  {
    label: `2 Samples (uses ${CREDITS_PER_IMAGE * 2} credits)`,
    value: 2,
  },
  {
    label: `3 Samples (uses ${CREDITS_PER_IMAGE * 3} credits)`,
    value: 3,
  },
  // {
  //   label: `4 Samples (uses ${CREDITS_PER_IMAGE * 4} credits)`,
  //   value: 4,
  // },
];